import React, { useState } from 'react';
import Mekelebanner from '../../../assets/images/icons/mekele.png';
import Dean from '../../../assets/images/icons/meskelDean.jpg';
import MekeleStudent from '../../../assets/images/icons/mekelestudent.jpg';
import accreditationImage from '../../../assets/images/icons/meskelUG.jpg';
import accreditationImage1 from '../../../assets/images/icons/meskelUG.jpg';
import AccreditationModal from './AccreditationModal'; // Adjust the import path as necessary

const Meskel = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage('');
  };

  return (
    <div>
      <div className="banner-slide">
        <img src={Mekelebanner} alt="Banner" className="banner-image" />
        <div className="banner-content">
          <h2>Empowering Students at Our Private University</h2>
          <p>We offer high-quality education and dedicated support, ensuring every student has a transformative experience.</p>
        </div>
      </div>

      <section className="projects-details">
        <div className="auto-container">
          <div className="sec-title style-two">
            <h3>MESKEL CAMPUS</h3>
          </div>
          <div className="text-block">
            <div className="row">
              <div className="col-lg-8">
                <h4>MESSAGE FROM CAMPUS DEAN</h4>
                <div className="text">
                  <p>
                    Welcome to Admas University Meskel Campus. We are dedicated to 
                    <strong> academic excellence, innovation, and student success</strong>. 
                    As one of Ethiopia’s leading private universities, we offer 
                    <strong> industry-relevant programs, modern learning facilities, and a dynamic educational environment</strong> 
                    that prepares students for the future.
                  </p>
                  <p>
                    Our commitment to <strong>quality education</strong> extends beyond the classroom, 
                    ensuring that students gain <em>practical skills, critical thinking abilities, and leadership qualities</em> 
                    to excel in today’s competitive world.
                  </p>
                  <p>
                    Join us in shaping the future! Whether you are a prospective student, researcher, or industry partner, 
                    <strong> Admas University Meskel Campus</strong> is the place where <em>opportunity meets excellence</em>.
                  </p>
                  <h5>📍 Admas University Meskel Campus – Your Future Starts Here!</h5>
                </div>
              </div>
              <div className="col-lg-3">
                <figure className="image pht">
                  <img src={Dean} alt="Dean" />
                  <figcaption>Abubeker Abdu (MA)</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <div className="sec-title style-two">
                  <h4>ACCREDITED PROGRAMS</h4>
                </div>
                <h6>UNDERGRADUATE PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Business Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Marketing Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Computer Science</div></li>
                </ul>

                <h6>TVET PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Web Development & Database Administration Level 1-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Hardware & Networking Servicing Level 1-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Secretarial Science & Office Administration Level 2-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Marketing & Sales Management Level 2-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance Level 2-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Human Resource Management Level 2-4</div></li>
                </ul>
              </div>
              <div className="col-lg-6">
               <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5696617448702!2d38.75639607205443!3d9.011685291048929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8597c62db057%3A0xf4d5e9a2d5ad5bd4!2zQWRtYXMgVW5pdmVyc2l0eSB8IE1lc2tlbCBTcXVhcmUgfCDhiqDhi7XhiJvhiLUg4Yup4YqS4Ymo4Yit4Yi14YmyIHwg4YiY4Yi14YmA4YiNIOGKoOGLsOGJo-GJo-GLrQ!5e0!3m2!1sen!2set!4v1744793436759!5m2!1sen!2set"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Admas University Meskel Campus Location"
                  ></iframe>
                </div>
                <div className="accreditation">
                  <h5>CERTIFICATE OF ACCREDITATION</h5>
                  <img 
                    src={accreditationImage1} 
                    alt="Accreditation Letter" 
                    style={{ width: '150px', cursor: 'pointer' }} 
                    onClick={() => openModal(accreditationImage1)} 
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="text-block-two">
            <div className="row">
              <div className="col-lg-6">
                <h4>STUDENT LIFE @ MESKEL CAMPUS</h4>
                <div className="text">
                  Meskel Campus of Admas University stands out as the premier destination for learning, providing an enriching environment for both postgraduate and undergraduate students. With state-of-the-art facilities, dedicated faculty, and a vibrant student community, it fosters academic excellence and personal growth.
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image"><img src={MekeleStudent} alt="Students at Meskel Campus" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AccreditationModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        images={[accreditationImage, accreditationImage1]} 
      />
    </div>
  );
};

export default Meskel;
